import { render, staticRenderFns } from "./Rp.vue?vue&type=template&id=1516b4fd"
import script from "./Rp.vue?vue&type=script&lang=js"
export * from "./Rp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports